import React from "react";
import { useSelector } from "react-redux";
import { makeStyles, Typography } from "@material-ui/core";

import DashImage from "../../Assets/DashImage.png";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "calc(100vh - 64px)",
    backgroundColor: "#ffffff",
  },
  greeting: {
    fontSize: 36,
    fontWeight: 700,
    color: "#333333",
    marginBottom: 32,
  },
  name: {
    color: "#2699FB",
  },
  image: {
    maxWidth: 620,
    width: "100%",
  },
}));

const Home = () => {
  const classes = useStyles();
  const name = useSelector((state) => state.auth.user?.name);

  return (
    <div className={classes.root}>
      <Typography className={classes.greeting}>
        Hi, <span className={classes.name}>{name}</span>
      </Typography>
      <img src={DashImage} alt="Dashboard" className={classes.image} />
    </div>
  );
};

export default Home;
